import axios from "axios";
import {getServerSession} from "next-auth";
import {authOptions} from "@/lib/authOptions";

const BASE_URL = process.env.API_URL ?? process.env.NEXT_PUBLIC_API_URL;

export default axios.create({
    baseURL : BASE_URL,
    headers : {"Content-Type" : "application/json"}
});

export const axiosAuth = axios.create({
    baseURL : BASE_URL,
    headers : {"Content-Type" : "application/json"}
});

export async function getServerAxios(){
    const token = "Bearer" + (await getServerSession(authOptions))?.user?.access_token;
    return axios.create({
        baseURL : BASE_URL,
        headers : {
            "Content-Type": "application/json",
            "Authorization": token
        }
    })
}
